import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import axios from 'axios';
import '../styles/Earnings.css';

const Earnings = () => {
  const [earningsData, setEarningsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stripeAccountId, setStripeAccountId] = useState(null);
  const [plan, setPlan] = useState(null);
  const navigate = useNavigate();
  const auth = getAuth();

  useEffect(() => {
    const fetchUserPlan = async () => {
      try {
        const user = auth.currentUser;
        if (user) {
          const token = await user.getIdToken();
          const response = await axios.get(
            `https://sync-api-troz.onrender.com/api/users/firebase/${user.uid}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          setPlan(response.data.plan);
        }
      } catch (error) {
        console.error('Error fetching user plan:', error);
      }
    };

    fetchUserPlan();
  }, [auth.currentUser]);

  useEffect(() => {
    const fetchEarnings = async () => {
      try {
        setLoading(true);
        setError(null);

        const currentUser = auth.currentUser;

        if (!currentUser) {
          throw new Error('User is not logged in.');
        }

        const uid = currentUser.uid;
        console.log('Fetching earnings for user UID:', uid);

        const userResponse = await axios.get(`https://sync-api-troz.onrender.com/api/users/firebase/${uid}`);
        setPlan(userResponse.data.plan);

        if (userResponse.data.plan !== 'premium') {
          throw new Error('SyncPro required to access earnings.');
        }

        const response = await axios.get(`https://sync-api-troz.onrender.com/api/users/firebase/${uid}/payout`);
        const data = response.data;

        setEarningsData(data);
        setStripeAccountId(data.stripeAccountId || null);
      } catch (err) {
        console.log('Error fetching earnings:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchEarnings();
  }, []);

  const handleStripeSetup = async () => {
    try {
      const currentUser = auth.currentUser;

      const response = await axios.post(
        `https://sync-api-troz.onrender.com/api/create-stripe-account`,
        { firebaseUid: currentUser.uid }
      );

      if (response.data.url) {
        window.location.href = response.data.url; // Redirect to Stripe setup
      }
    } catch (error) {
      console.error('Error setting up Stripe:', error);
      alert('Failed to set up payments.');
    }
  };

  if (loading) {
    return (
      <div className="earnings-center">
        <div className="earnings-spinner"></div>
        <p className="earnings-loading-text">Loading earnings data...</p>
      </div>
    );
  }

  if (plan !== 'premium') {
    return (
      <div className="earnings-center">
        <p className="earnings-error-text">
          <span className="earnings-highlight">SyncPro</span> is required to start earning.
        </p>
        <button
          className="earnings-upgrade-button"
          onClick={() => navigate('/subscription')}
        >
          Upgrade to SyncPro
        </button>
      </div>
    );
  }

  return (
    <div className="earnings-container">
      <div className="earnings-content">
        <h1 className="earnings-title">Earnings</h1>

        {earningsData ? (
          <>
            <div className="earnings-card">
              <h2 className="earnings-card-title">Platform Monthly Streams</h2>
              <p className="earnings-card-value">{earningsData.totalStreams}</p>
            </div>
            <div className="earnings-card">
              <h2 className="earnings-card-title">Your Monthly Streams</h2>
              <p className="earnings-card-value">{earningsData.userMonthlyStreams}</p>
            </div>
            <div className="earnings-card">
              <h2 className="earnings-card-title">Your Share of Stream Pool</h2>
              <p className="earnings-card-value">{earningsData.poolPercentage}%</p>
            </div>
            {!stripeAccountId && (
              <button
                className="earnings-setup-button"
                onClick={handleStripeSetup}
              >
                Set Up Payments
              </button>
            )}
            <p className="earnings-note-text">
              Note: Payouts are processed manually each month via Stripe based on subscription revenue.
            </p>
          </>
        ) : (
          <p className="earnings-no-data-text">No earnings data available.</p>
        )}
      </div>
    </div>
  );
};

export default Earnings;